import * as types from 'models/actionTypes'

const initialState = {
    renderer: null,
    contextInfo: null,
    hasRendered: false,
    isLowPerformanceDevice: false, // set once a renderer is created and keeps its value after the renderer is destroyed.
}

const renderer = (state = initialState, action) => {
    switch (action.type) {
        case types.NEW_RENDERER:
            return {
                ...state,
                renderer: true,
                contextInfo: null,
                hasRendered: false,
            }
        case types.DESTROY_RENDERER:
            return {
                ...state,
                renderer: null,
                contextInfo: null,
                hasRendered: false,
            }
        case types.RENDERER_READY: {
            const isLowPerformanceDevice = !!(action.contextInfo && action.contextInfo.software)
            return {
                ...state,
                contextInfo: action.contextInfo,
                isLowPerformanceDevice,
            }
        }
        case types.FIRST_RENDER:
            return {
                ...state,
                hasRendered: true,
            }
        case types.INITIALIZATION_FAILURE:
            return {
                ...state,
                isLowPerformanceDevice: !!action.info.webglfailure,
            }
        default:
            return state
    }
}

export default renderer
